import { put, select, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import qs from 'querystring'
import { waitFor } from 'gnos-utilities/sagas'

import { replace, LOCATION_CHANGE } from 'connected-react-router'

import config from '@config'

import { createLoadModuleAccessRightAction } from '../authorization/helpers'
import { login } from '../authorization/actions'

import { uniqueIdSelector, sessionIdSelector, getActiveModule, hasRightsLoaded } from './selectors'
import { SET_ACTIVE_MODULE, AUTOLOGIN_ROUTE } from './constants'
import { setActiveModule } from './actions'

// get data from config modules
const defaultModuleRoute = _.get(_.find(config.modules, { initial: true }), 'route', '')
const moduleRoutes = _.map(config.modules, (module) => module.route)
const languages = _.map(config.languages, (language) => language.key)

function* routingCallSaga(_action) {
    // get base root path (e.g. report, home, etc...)
    const rootPath = _.first(_.drop(_.split(_action.payload.location.pathname, /[/\?]/g))) // eslint-disable-line no-useless-escape

    // must be existing route in modules config or empty route (root)
    const isModuleRoute = moduleRoutes.indexOf(rootPath) !== -1 || _.isEmpty(rootPath)

    // process module routes
    if (isModuleRoute) {
        if (!config.iframeSolution) {
            const route = rootPath || defaultModuleRoute
            const module = _.get(_.find(config.modules, { route }), 'key', defaultModuleRoute)

            const currentActiveModule = yield select(getActiveModule)

            if (module !== currentActiveModule) yield put(setActiveModule(module, true))
        }

        return null
    }

    // process autologin route
    if (rootPath === AUTOLOGIN_ROUTE) {
        const params = qs.parse(_.trim(_action.payload.location.search, '?'))
        const sessionId = _.get(params, 'sid', null)
        const uniqueId = _.get(params, 'uid', null)
        const module = _.get(params, 'module', null)
        const id = _.get(params, 'id', null)
        const lang = _.get(params, 'lang', null)

        const redirectModule = _.includes(moduleRoutes, module) ? module : null
        const language = _.includes(languages, lang) ? lang : null

        yield put(replace('/'))
        yield put(login({ uniqueId, sessionId, redirectModule, id, language, autologin: true }))

        return null
    }

    // last option is route to root
    yield put(replace('/'))

    return null
}

function* setActiveModuleSaga(_action) {
    const module = _.get(_action, 'data.module', null)
    const noRouter = _.get(_action, 'data.noRouter', false)
    const route = config.modules[module].route
    const uniqueId = yield select(uniqueIdSelector)

    if (!noRouter) yield put(replace(`/${route}`))

    const isRightLoaded = yield select(hasRightsLoaded, module)
    if (!isRightLoaded) {
        yield waitFor(uniqueId ? uniqueIdSelector : sessionIdSelector)
        yield put(createLoadModuleAccessRightAction(module))
    }
}

export default function* routingSaga() {
    yield takeEvery(LOCATION_CHANGE, routingCallSaga)
    yield takeEvery(SET_ACTIVE_MODULE, setActiveModuleSaga)
}
